import { Button } from "src/components/button/Button";
import type { Merge } from "src/models/utility";
import { PopoverTrigger } from "../trigger/Popover.trigger";

export namespace PopoverButton {
	export type ElementName = "Popover.Button";
	export type ElementType = HTMLButtonElement;
	export type Props = Merge<Omit<PopoverTrigger.Props, "render">, Button.Props> & {};
}

export const PopoverButton = (componentProps: PopoverButton.Props) => {
	const { ...restProps } = componentProps;

	return <PopoverTrigger render={<Button {...restProps} />} />;
};
